import { api } from './axios';
import { authService } from './auth';
import type { Notificacao } from '../models';

class NotificacaoService {
  /**
   * Listar notificações não visualizadas do usuário logado
   */
  async getNotificacoes(): Promise<Notificacao[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Notificacao[]>('/notificacoes');
    return response.data;
  }

  /**
   * Listar todas as notificações (lidas e não lidas) do usuário logado
   */
  async getTodasNotificacoes(filtros?: {
    visualizado?: boolean
    periodo?: 'hoje' | 'semana' | 'mes'
    data_inicio?: string
    data_fim?: string
    status_demanda?: string
    tipo?: string
  }): Promise<Notificacao[]> {
    await authService.ensureSanctumInitialized();
    
    const params = new URLSearchParams()
    
    if (filtros) {
      if (filtros.visualizado !== undefined) {
        params.append('visualizado', String(filtros.visualizado))
      }
      if (filtros.periodo) {
        params.append('periodo', filtros.periodo)
      }
      if (filtros.data_inicio) {
        params.append('data_inicio', filtros.data_inicio)
      }
      if (filtros.data_fim) {
        params.append('data_fim', filtros.data_fim)
      }
      if (filtros.status_demanda) {
        params.append('status_demanda', filtros.status_demanda)
      }
      if (filtros.tipo) {
        params.append('tipo', filtros.tipo)
      }
    }
    
    const queryString = params.toString()
    const url = queryString ? `/notificacoes/todas?${queryString}` : '/notificacoes/todas'
    
    const response = await api.get<Notificacao[]>(url);
    return response.data;
  }

  /**
   * Marcar notificação como visualizada
   */
  async marcarComoVisualizada(notificacaoId: number): Promise<{ message: string }> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.post<{ message: string }>(`/notificacao/${notificacaoId}/visualizar`);
    return response.data;
  }

  /**
   * Marcar múltiplas notificações como visualizadas (em massa)
   */
  async marcarVariasComoVisualizadas(notificacaoIds: number[]): Promise<{ message: string; updated_count: number }> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.post<{ message: string; updated_count: number }>(
      '/notificacoes/visualizar-massa',
      { notificacao_ids: notificacaoIds }
    );
    return response.data;
  }

  /**
   * Marcar todas as notificações não lidas como visualizadas
   */
  async marcarTodasComoVisualizadas(): Promise<{ message: string; updated_count: number }> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.post<{ message: string; updated_count: number }>(
      '/notificacoes/visualizar-todas'
    );
    return response.data;
  }

  /**
   * Conta notificações não visualizadas
   */
  async contarNaoVisualizadas(): Promise<number> {
    const notificacoes = await this.getNotificacoes();
    return notificacoes.filter(n => !n.visualizado).length;
  }

  /**
   * Ativar/Desativar recebimento de emails do usuário logado
   */
  async toggleReceberEmails(): Promise<{ message: string; emails: boolean }> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.post<{ message: string; emails: boolean }>('/usuario/receber-emails');
    return response.data;
  }
}

export const notificacaoService = new NotificacaoService();
